import { Parallax } from "react-parallax";
import { Link } from "react-scroll";
import Navbar from "../layout/NavbarReveal";
import Hero from "../section/heroLightNew";
import About from "../section/aboutLight";
import Blockquote from "../section/blockquoteLightNew";
import Whatido from "../section/whatido";
import Gallery from "../section/gallery";
import Resume from "../section/resume";
import Counter from "../section/counterLightNew";
import Blog from "../section/blog";
import Contact from "../section/contactLightNew";
import Footer from "../section/footer";
import Preloader from "../layout/Preloader";
import ScrollToTopBtn from "../layout/ScrollToTop";
import { GlobalStyles } from "./style/lightnew";

const image1 = "./img/background/l5.jpg";

function home() {
  return (
    <>
      <GlobalStyles />
      <Preloader />
      <div className="home">
        <Navbar />

        {/* HERO */}
        <section id="hero-area" className="bg-bottom py-0">
          <Parallax bgImage={image1} strength={300}>
            <Hero />
            <Link smooth spy to="about">
              <span className="mouse transition" id="fly">
                <span className="scroll"></span>
              </span>
            </Link>
          </Parallax>
        </section>

        {/* ABOUT */}
        <section id="about" className="pb-0">
          <About />
        </section>

        {/* What I DO */}
        <section id="whatido">
          <Whatido />
          <Blockquote />
        </section>

        {/* Gallery */}
        <section id="gallery">
          <Gallery />
        </section>

        {/* Gallery */}
        <section id="resume" className="pb-0">
          <Resume />
          <Counter />
        </section>

        {/* Gallery */}
        {/* <section id="blog" className="pb-0">
          <Blog />
        </section> */}

        {/* contact */}
        <section id="contact" className="py-0">
          <Contact />
          <Footer />
        </section>

        <div className="float-text">
          <div className="de_social-icons">
            {/* <span className="buton">
              <i className="fa fa-twitter fa-lg"></i>
            </span>
            <span className="buton">
              <i className="fa fa-instagram fa-lg"></i>
            </span> */}
            <a
              href="https://www.facebook.com/Yosra.glh"
              target="_blank"
              className="buton"
              rel="noreferrer"
            >
              <i className="fa fa-facebook fa-lg"></i>
            </a>
            <a
              href="https://github.com/Yusra-glh"
              target="_blank"
              className="buton"
              rel="noreferrer"
            >
              <i className="fa fa-github fa-lg"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/yosra-gallah/"
              target="_blank"
              className="buton"
              rel="noreferrer"
            >
              <i className="fa fa-linkedin fa-lg"></i>
            </a>
          </div>
          <span>Follow Me</span>
        </div>
      </div>
      <ScrollToTopBtn />
    </>
  );
}

export default home;
